<template>
  <v-flex class="section-1 general-bg" ma-0 pt-4 px-4>
    <h3 class="text-xs-left pt-2">Historial de acciones</h3>
    <h4 class="text-xs-left pt-2">Reporte por Tiempo</h4>
    <!-- DATE & TIME -->
    <v-flex d-flex px-1 mt-3>
      <!-- DATE INTERVAL FOR DATE1 -->
      <v-flex class="section-right-in" xs6 mr-3>
        <!-- DATE 1 SELECTOR -->
        <v-flex>
          <v-menu
            ref="menu1"
            v-model="menu1"
            transition="scale-transition"
            lazy
            offset-x
            left
            full-width
            origin="top left"
            nudge-right="300"
            nudge-top="-40"
            color="white"
            :return-value.sync="dates1"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on }">
              <v-combobox
                v-model="dates1"
                multiple
                chips
                small-chips
                box
                label="Escoger el día inicial"
                prepend-inner-icon="event"
                readonly
                color="white"
                v-on="on"
              ></v-combobox>
            </template>
            <v-date-picker
              v-model="dates1"
              multiple
              no-title
              scrollable
              locale="es-sp"
              color="blue accent-3"
              :first-day-of-week="1"
              :allowed-dates="allowedDates1"
              @input="changesOnDate1"
            >
              <v-spacer></v-spacer>
              <v-btn
                color="error"
                @click="menu1 = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                @click="$refs.menu1.save(dates1)"
              >
                Aceptar
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-flex>
         <!-- SELECT TIMES DATE 1 -->
        <v-flex v-if="dates1.length > 0">
          <!-- TIME 1 DATE 1 -->
          <v-flex class="container-date-1" py-2 d-inline-flex px-5 align-center>
            <v-flex>
              <v-icon>event</v-icon>
            </v-flex>
            <v-flex pl-1>
              Fecha Inicial:
            </v-flex>
            <v-flex class="style-date-h" pl-2>
              {{ dates1[0] | moment("DD/MM/YYYY") }}
            </v-flex>
          </v-flex>
          <!-- MENU TIME 1 DATE 1 -->
          <v-flex mt-3>
            <v-menu
              ref="time1Date1Menu"
              v-model="time1Date1Menu"
              class="mx-1"
              lazy
              transition="scale-transition"
              offset-x
              left
              full-width
              allow-overflow
              min-width="290px"
              origin="top left"
              nudge-right="750"
              nudge-bottom="0"
              :return-value.sync="time1Date1"
              :close-on-content-click="false"
            >
              <v-text-field
                v-model="time1Date1"
                label="Hora Inicial"
                slot="activator"
                placeholder="Seleccionar Hora"
                prepend-inner-icon="av_timer"
                readonly
                box
                hide-details
                color="white"
                clearable
              />
              <v-time-picker
                v-model="time1Date1"
                landscape
                format="24hr"
                scrollable
                color="teal darken-1"
                header-color="grey darken-4"
                :allowed-hours="allowedHours0"
                :allowed-minutes="allowedMinutes0"
                @click:hour="clickOnHourTime1Date1"
                @input="changesOnTime1Date1"
              >
                <v-spacer></v-spacer>
                <v-btn
                  color="error"
                  @click="time1Date1Menu = false"
                >
                  Cancelar
                </v-btn>
                <v-btn 
                  color="primary" 
                  @click="$refs.time1Date1Menu.save(time1Date1)"
                >
                  Aceptar
                </v-btn>
              </v-time-picker>
            </v-menu>
          </v-flex>
          <!-- TIME 2 DATE 1 MENU -->
          <v-flex v-if="time1Date1 !== null && dates2.length === 0" mt-3>
            <v-menu
              ref="time2Date1Menu"
              v-model="time2Date1Menu"
              class="mx-1"
              lazy
              transition="scale-transition"
              offset-x
              left
              full-width
              min-width="290px"
              origin="top left"
              nudge-right="750"
              nudge-bottom="0"
              :return-value.sync="time2Date1"
              :close-on-content-click="false"
            >
              <v-text-field
                v-model="time2Date1"
                label="Hora Final"
                slot="activator"
                placeholder="Seleccionar Hora"
                prepend-inner-icon="av_timer"
                readonly
                box
                hide-details
                color="white"
                clearable
              />
              <v-time-picker
                v-model="time2Date1"
                landscape
                format="24hr"
                scrollable
                color="red darken-1"
                header-color="grey darken-4"
                :allowed-hours="allowedHours1"
                :allowed-minutes="allowedMinutes1"
                @click:hour="clickOnHourTime2Date1"
              >
                <v-spacer></v-spacer>
                <v-btn
                  color="error"
                  @click="time2Date1Menu = false"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  @click="$refs.time2Date1Menu.save(time2Date1)"
                >
                  Aceptar
                </v-btn>
              </v-time-picker>
            </v-menu>
          </v-flex>
        </v-flex>
      </v-flex>
      <!-- ////////////////////////////////////////////////////////// -->
      <!-- DATE INTERVAL FOR DATE2 -->
      <!-- ////////////////////////////////////////////////////////// -->
      <v-flex
        v-if="time1Date1 !== null && dates1.length > 0"
        class="section-right-in"
        xs6
        ml-3
      >
        <!-- DATE 2 SELECTOR -->
        <v-flex>
          <v-menu
            ref="menu2"
            v-model="menu2"
            lazy
            transition="scale-transition"
            offset-x
            left
            full-width
            origin="top left"
            nudge-right="300"
            nudge-top="-40"
            color="white"
            :return-value.sync="dates2"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on }">
              <v-combobox
                v-model="dates2"
                multiple
                chips
                small-chips
                box
                label="Escoger el día final"
                prepend-inner-icon="event"
                readonly
                color="white"
                v-on="on"
              ></v-combobox>
            </template>
            <v-date-picker
              v-model="dates2"
              multiple
              no-title
              scrollable
              locale="es-sp"
              color="blue accent-3"
              :first-day-of-week="1"
              :allowed-dates="allowedDates2"
              @input="changesOnDate2"
            >
              <v-spacer></v-spacer>
              <v-btn
                color="error"
                @click="menu2 = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                @click="$refs.menu2.save(dates2)"
              >
                Aceptar
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <!-- SELECT TIME DATE 2-->
        <v-flex v-if="!!dates2[0]">
          <!-- TIME 1 DATE 2 -->
          <v-flex class="container-date-2" py-2 d-inline-flex px-5 align-center>
            <v-flex>
              <v-icon>event</v-icon>
            </v-flex>
            <v-flex pl-1>
              Fecha Final:
            </v-flex>
            <v-flex class="style-date-h" pl-2>
              {{ dates2[0] | moment("DD/MM/YYYY") }}
            </v-flex>
          </v-flex>
          <!-- MENU TIME 1 DATE 2 -->
          <v-flex mt-3>
            <v-menu
              ref="time1Date2Menu"
              v-model="time1Date2Menu"
              class="mx-1"
              transition="scale-transition"
              min-width="290px"
              origin="top left"
              nudge-right="750"
              nudge-bottom="0"
              lazy
              offset-x
              left
              full-width
              allow-overflow
              :return-value.sync="time1Date2"
              :close-on-content-click="false"
            >
              <v-text-field
                v-model="time1Date2"
                label="Hora Final"
                slot="activator"
                placeholder="Seleccionar Hora"
                prepend-inner-icon="av_timer"
                color="white"
                readonly
                box
                hide-details
                clearable
              />
              <v-time-picker
                v-model="time1Date2"
                format="24hr"
                color="red darken-1"
                header-color="grey darken-4"
                landscape
                scrollable
                :allowed-hours="allowedHours2"
                :allowed-minutes="allowedMinutes2"
                @click:hour="clickOnHourTime1Date2"
              >
                <v-spacer></v-spacer>
                <v-flex class="text-xs-center">
                  <v-btn
                    color="error"
                    @click="time1Date2Menu = false"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="$refs.time1Date2Menu.save(time1Date2)"
                  >
                    Aceptar
                  </v-btn>
                </v-flex>
              </v-time-picker>
            </v-menu>
          </v-flex>
        </v-flex>
      </v-flex>
    </v-flex>
    <!-- BUTTON -->
    <v-flex class="text-xs-center" my-5 pb-3>
      <v-btn
        v-if="!reportReadyLH"
        target="_blank"
        color="primary"
        :disabled="getReportDisabled"
        :loading="$loading.isLoading('generatingLogsHistoryReport')"
        @click="downloadLogsHistoryReport"
      >
        <v-icon left>description</v-icon>
        Generar Reporte
      </v-btn>
      <v-btn
        v-if="reportReadyLH"
        color="success"
        target="_blank"
        :href="urlReportLH"
        @click="resetAll"
      >
        <v-icon left>cloud_download</v-icon>
        Descargar Reporte
      </v-btn>
    </v-flex>
  </v-flex>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'report-logs-history',
  data() {
    return {
      menu1: false,
      dates1: [],
      time1Date1Menu: false,
      time1Date1: null,
      time2Date1Menu: false,
      time2Date1: null,
      dates2: [],
      menu2: false,
      time1Date2Menu: false,
      time1Date2: null,
      fromDateAllowed: '2021-10-05'
    }
  },
  computed: {
    ...mapGetters(['reportReadyLH', 'urlReportLH']),
    getReportDisabled() {
      let result = true
      if (this.dates1.length === 1 && this.dates2.length === 0 && this.time1Date1 && this.time2Date1) result = false
      else if (this.dates2.length === 1 && this.time1Date1 && this.time1Date2) result = false
      return result
    }
  },
  methods: {
    ...mapActions(['toggleBtnLHR', 'getLogHistoryReport']),
    time1Date1IsTodayCheck() {
      let today = this.$moment.now()
      today = this.$moment(today).format('YYYY-MM-DD')
      const result = this.$moment(today).isSame(this.dates1[0])
      return result
    },
    allowedDates1(date) {
      let today = this.$moment.now()
      let datesResult = this.$moment(date).isAfter(this.fromDateAllowed) && this.$moment(date).isBefore(today)
      today = this.$moment(today).format('YYYY-MM-DD')

      if (this.dates1.length === 1) datesResult = date === this.dates1[0]

      return datesResult
    },
    changesOnDate1() {
      this.dates2 = []
      this.time1Date1 = null
      this.time1Date2 = null
    },
    changesOnTime1Date1() {
      this.dates2 = []
      this.time2Date1 = null
      this.time1Date2 = null
    },
    allowedHours0(value) {
      let result = true
      const today = this.$moment.now()
      const currentHour = Number(this.$moment(today).format('HH'))
      if (this.time1Date1IsTodayCheck()) result = value <= currentHour
      return result
    },
    allowedMinutes0(value) {
      let result = true
      if (this.time1Date1IsTodayCheck()) {
        const today = this.$moment.now()
        const currentHour = Number(this.$moment(today).format('HH'))
        const currentMinute = Number(this.$moment(today).format('mm'))

        const date0Time1 = this.$moment(`${this.dates1[0]} ${this.time1Date1}`)
        const hour1 = Number(this.$moment(date0Time1).format('HH'))

        result = hour1 === currentHour
          ? value <= currentMinute
          : true
      }
      return result
    },
    clickOnHourTime1Date1(value) {
      this.time1Date1 = `${String(value)}:00`
    },
    allowedHours1(value) {
      if (this.time2Date1 === null) this.time2Date1 = this.time1Date1

      const myDate = `${this.dates1[0]} ${this.time1Date1}`
      const selectedHour1 = this.time1Date1.split(':')
      const amountOfHours = 24 - Number(selectedHour1[0])
      const allowedHoursArray = []
      for (let i = 0; i < amountOfHours; i++) {
        const h = this.$moment(myDate).add(i, 'hours').format('H')
        allowedHoursArray.push(Number(h))
      }

      const today = this.$moment.now()
      const currentHour = Number(this.$moment(today).format('HH'))

      const isIn = this.time1Date1IsTodayCheck()
        ? allowedHoursArray.filter(item => item === value && item <= currentHour)
        : allowedHoursArray.filter(item => item === value)

      const result = isIn.length > 0
      return result
    },
    allowedMinutes1(value) {
      if (this.time2Date1 !== null) {
        const today = this.$moment.now()
        const currentHour = Number(this.$moment(today).format('HH'))
        const currentMinute = Number(this.$moment(today).format('mm'))

        const selectedHour2 = this.time2Date1.split(':')
        const selectedHour1 = this.time1Date1.split(':')
        const hour1 = Number(selectedHour1[0])
        const minute1 = Number(selectedHour1[1])

        if (Number(selectedHour2[0]) === hour1) {
          const result = hour1 === Number(currentHour) && this.time1Date1IsTodayCheck()
            ? value > minute1 && value <= currentMinute
            : value > minute1
          return result
        } else if (
          Number(selectedHour2[0]) === Number(currentHour) &&
          this.time1Date1IsTodayCheck()
        ) {
          const result = value <= currentMinute
          return result
        }
      }
      return true
    },
    clickOnHourTime2Date1(value) {
      const time1Date1Split = this.time1Date1.split(':')
      if (value === Number(time1Date1Split[0])) {
        const minute = Number(time1Date1Split[1]) + 1
        const minuteFormated = minute < 10 ? `0${String(minute)}` : String(minute)
        this.time2Date1 = `${String(value)}:${minuteFormated}`
      } else this.time2Date1 = `${String(value)}:00`
    },
    allowedDates2(date) {
      let today = this.$moment.now()
      today = this.$moment(today).format('YYYY-MM-DD')
      if (today === this.dates1[0]) return false

      const dayAfter1 = this.$moment(this.dates1[0]).add(1, 'days').format('YYYY-MM-DD')
      let datesResult = date === dayAfter1
      return datesResult
    },
    changesOnDate2() {
      this.time1Date2 = null
    },
    allowedHours2(value) {
      const selectedHour1 = this.time1Date1.split(':')
      let result
      const today = this.$moment.now()
      const todayFormated = this.$moment(today).format('YYYY-MM-DD')
      if (todayFormated === this.dates2[0]) {
        const currentHour = Number(this.$moment(today).format('HH'))
        const diff24 = currentHour >= Number(selectedHour1[0])
        result = diff24 ? value <= Number(selectedHour1[0]) : value <= currentHour
      } else {
        result = value <= Number(selectedHour1[0])
      }
      return result
    },
    allowedMinutes2(value) {
      let result = true
      const initDay = this.$moment(this.dates1[0])
      const finalDay = this.$moment(this.dates2[0])
      const diffHours = Math.abs(finalDay.diff(initDay, 'hours'))
      if (this.time1Date2 !== null) {
        const selectedHour1 = this.time1Date1.split(':')
        const selectedHour2 = this.time1Date2.split(':')
        const hour1 = Number(selectedHour1[0])
        const hour2 = Number(selectedHour2[0])
        const minute1 = Number(selectedHour1[1])
        if (this.date2IsTodayCheck()) {
          const today = this.$moment.now()
          const currentHour = Number(this.$moment(today).format('HH'))
          const currentMinute = Number(this.$moment(today).format('mm'))
          if (hour2 === hour1 && diffHours >= 24) result = value <= minute1
          else {
            result = currentHour === hour2
              ? value <= currentMinute
              : true
          }
        } else if (hour2 === hour1 && diffHours >= 24) {
          result = value <= minute1
        }
      }
      return result
    },
    clickOnHourTime1Date2(value) {
      this.time1Date2 = `${String(value)}:00`
    },
    date2IsTodayCheck() {
      let today = this.$moment.now()
      today = this.$moment(today).format('YYYY-MM-DD')
      const result = this.$moment(today).isSame(this.dates2[0])
      return result
    },
    downloadLogsHistoryReport() {
      const startDate = `${this.dates1[0]} ${this.time1Date1}`
      let endDate = `${this.dates1[0]} ${this.time2Date1}`
      if (this.dates2[0]) {
        endDate = `${this.dates2[0]} ${this.time1Date2}`
      }
      const payload = {
        startDate,
        endDate
      }
      this.getLogHistoryReport(payload)
    },
    resetAll() {
      this.dates1 = []
      this.time1Date1 = null
      this.time2Date1 = null
      this.dates2 = []
      this.time1Date2 = null
      this.toggleBtnLHR(false)
    }
  }
}
</script>

<style lang="stylus" scoped>
h3
  font-size 30px
  font-weight 500
  line-height 7px

h4
  font-size 21px
  font-weight 500

.section-1
  min-width max-content
  
.general-bg
  background-color #424242
  border-radius 3px

.section-right-in
  min-width 325px
  max-width 325px

.container-date-1
  background-color #00897B
  border-radius 30px

.container-date-2
  background-color #E53935
  border-radius 30px

.style-date-h
  font-weight 600
  font-size 16px
</style>


// WEBPACK FOOTER //
// src/components/Reports/ReportLogsHistory.vue